var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWorkSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 62 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4211 12.7105H43.2105V6.60526C43.2105 3.21684 40.4937 0.5 37.1053 0.5H24.8947C21.5063 0.5 18.7895 3.21684 18.7895 6.60526V12.7105H6.57896C3.19054 12.7105 0.50422 15.4274 0.50422 18.8158L0.473694 52.3947C0.473694 55.7832 3.19054 58.5 6.57896 58.5H55.4211C58.8095 58.5 61.5263 55.7832 61.5263 52.3947V18.8158C61.5263 15.4274 58.8095 12.7105 55.4211 12.7105ZM37.1053 12.7105H24.8947V6.60526H37.1053V12.7105Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkSuitcase);
export default __webpack_public_path__ + "static/media/icon_work-suitcase.a8fcf586cce4d84a5c72a880286d14db.svg";
export { ForwardRef as ReactComponent };